import type { Control } from 'react-hook-form';
import { useWatch } from 'react-hook-form';
import type { RuleTargetType } from '../ruleTypes';
import type { RuleFormValues } from './ruleFormSchema';

export const useRuleTargetType = (
  control: Control<RuleFormValues>,
): RuleTargetType => {
  const type = useWatch({ control, name: 'type' });
  return type === 'intL2' ? 'intL2' : 'device';
};
